import apiService from "../../services/apiService";

const CART_API = process.env.REACT_APP_BACKEND_API;

export const getUserCarts = async () => {
  const { data } = await apiService.get(`${CART_API}backend/carts`);
  return data?.data || [];
};

export const addtoCart = async (body) => {
  const { data } = await apiService.create(`${CART_API}backend/cart`, body);
  return data?.data || {};
};

export const increaseCartQuantity = async (body) => {
  const { data } = await apiService.post(
    `${CART_API}backend/cart/increase`,
    body
  );
  return data?.data || {};
};

export const decreaseCartQuantity = async (body) => {
  const { data } = await apiService.post(
    `${CART_API}backend/cart/decrease`,
    body
  );
  return data?.data || {};
};

export const removeCartItem = async (id) => {
  const { data } = await apiService.remove(`${CART_API}backend/cart`, id);
  return data?.data || {};
};
